var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 233,
    viewBox: "0 0 183 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1645)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.517,
    height: 233,
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 182.517,
    height: 233,
    fill: "#FFD5CC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.517 0H0V233H182.517V0ZM25.0806 9.70825C15.4294 9.70825 7.60557 17.5321 7.60557 27.1832V205.817C7.60557 215.468 15.4294 223.292 25.0806 223.292H157.438C167.089 223.292 174.913 215.468 174.913 205.817V27.1832C174.913 17.5321 167.089 9.70825 157.438 9.70825H25.0806Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.475 109.68C133.842 125.376 125.885 148.84 105.578 158.41C100.474 160.815 97.6382 158.481 91.4829 158.778C85.9831 159.043 84.2841 160.983 79.046 159.107C57.2943 151.319 47.6361 128.507 47.2433 111.694C46.7297 89.7137 64.7098 78.1019 89.9331 92.4456C112.82 77.8075 132.962 87.699 133.475 109.68Z",
    fill: "#FF542F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8272 88.1369C77.3495 81.5761 65.9057 80.7204 57.2469 85.1248C48.0442 89.8058 43.2356 99.783 43.5159 111.782C43.931 129.547 54.0994 154.136 77.7898 162.618C81.0632 163.79 83.4397 163.8 85.7581 163.428C86.5543 163.3 87.2044 163.165 87.8158 163.039C88.9878 162.796 90.0178 162.582 91.6633 162.503C93.619 162.409 95.0272 162.611 96.628 162.84C97.2128 162.924 97.8233 163.011 98.4956 163.089C101.036 163.384 103.782 163.379 107.169 161.783C129.271 151.368 137.592 126.176 137.204 109.593C136.92 97.4262 131.108 87.9685 121.556 83.9C112.619 80.0933 101.31 81.3876 89.8272 88.1369ZM105.579 158.41C125.886 148.84 133.843 125.376 133.476 109.68C132.963 87.6993 112.821 77.8078 89.9339 92.4458C64.7106 78.1022 46.7305 89.714 47.2441 111.695C47.6369 128.508 57.2951 151.32 79.0468 159.108C82.4477 160.325 84.3567 159.935 86.7827 159.438C88.0933 159.17 89.5547 158.871 91.4837 158.778C93.8243 158.665 95.685 158.933 97.373 159.176C100.124 159.571 102.416 159.901 105.579 158.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2858 148.457C117.592 138.887 123.891 115.423 123.524 99.7268C123.417 95.1303 122.451 91.0624 120.781 87.637C128.352 91.1859 133.228 99.0079 133.477 109.679C133.844 125.375 125.886 148.84 105.58 158.41C102.417 159.9 100.125 159.571 97.3737 159.175C95.6857 158.932 93.825 158.665 91.4844 158.778C89.5554 158.871 88.094 159.17 86.7834 159.438C84.3574 159.934 82.4484 160.325 79.0475 159.107C71.0917 156.259 64.7537 151.4 59.8952 145.561C62.201 146.967 64.7106 148.179 67.4362 149.154C70.944 150.41 73.6085 149.955 76.6378 149.438C78.1321 149.183 79.7151 148.913 81.5318 148.825C83.8128 148.715 85.8657 148.966 87.8061 149.204C91.1021 149.607 94.0733 149.971 97.2858 148.457Z",
    fill: "#ED4A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 105.553C120.846 107.368 119.17 108.634 117.356 108.381C115.541 108.128 114.275 106.451 114.528 104.637C114.781 102.822 116.458 101.556 118.272 101.809C120.087 102.062 121.353 103.739 121.1 105.553Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.078 115.158C129.825 116.973 128.149 118.238 126.334 117.985C124.52 117.732 123.254 116.056 123.507 114.241C123.76 112.427 125.436 111.161 127.251 111.414C129.066 111.667 130.331 113.343 130.078 115.158Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.887 102.592C129.697 103.953 128.44 104.902 127.079 104.713C125.718 104.523 124.769 103.266 124.959 101.905C125.149 100.544 126.406 99.5942 127.767 99.7841C129.128 99.9739 130.077 101.231 129.887 102.592Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.816 126.696C126.563 128.511 124.886 129.777 123.072 129.524C121.257 129.271 119.991 127.594 120.244 125.78C120.497 123.965 122.174 122.699 123.988 122.952C125.803 123.205 127.069 124.882 126.816 126.696Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.837 117.092C117.584 118.906 115.908 120.172 114.093 119.919C112.278 119.666 111.012 117.99 111.266 116.175C111.519 114.36 113.195 113.095 115.01 113.348C116.824 113.601 118.09 115.277 117.837 117.092Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.341 139.274C121.087 141.088 119.411 142.354 117.597 142.101C115.782 141.848 114.516 140.172 114.769 138.357C115.022 136.542 116.699 135.277 118.513 135.53C120.328 135.783 121.594 137.459 121.341 139.274Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.676 129.217C114.422 131.032 112.746 132.297 110.931 132.044C109.117 131.791 107.851 130.115 108.104 128.3C108.357 126.486 110.034 125.22 111.848 125.473C113.663 125.726 114.929 127.402 114.676 129.217Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.764 146.638C114.574 147.999 113.317 148.948 111.956 148.758C110.595 148.568 109.646 147.311 109.836 145.95C110.026 144.589 111.283 143.64 112.644 143.83C114.005 144.019 114.954 145.277 114.764 146.638Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.544 58.487C108.544 58.487 112.23 73.6837 108.349 81.9574C103.671 91.9294 89.546 92.559 89.546 92.559C89.546 92.559 85.2692 80.9018 90.921 70.7656C95.2686 62.9685 108.544 58.487 108.544 58.487Z",
    fill: "#7CD623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.168 57.6082L108.544 58.4872L107.351 54.9539C108.342 54.6194 109.428 54.7163 110.344 55.2211C111.26 55.7258 111.922 56.5919 112.168 57.6082ZM105.039 59.8942C107.114 58.9699 108.544 58.4872 108.544 58.4872C108.544 58.4872 108.896 59.9388 109.268 62.1891C110.1 67.2196 111.03 76.241 108.349 81.9576C103.672 91.9296 89.5462 92.5592 89.5462 92.5592C89.5462 92.5592 85.2693 80.902 90.9211 70.7658C93.8418 65.5277 100.792 61.786 105.039 59.8942ZM89.5462 92.5592C86.0452 93.8437 86.0447 93.8424 86.0442 93.8411L86.0408 93.8318L86.035 93.8156L86.0188 93.7702C86.006 93.7343 85.9896 93.6871 85.9697 93.6289C85.9301 93.5126 85.8771 93.3525 85.8143 93.1519C85.6889 92.7509 85.5238 92.1859 85.3483 91.4834C84.9983 90.0826 84.6007 88.1111 84.399 85.7859C83.9993 81.178 84.3465 74.8995 87.6641 68.9497C90.3814 64.0764 95.6001 60.586 99.5849 58.4246C101.659 57.2996 103.578 56.4407 104.979 55.8624C105.681 55.5722 106.259 55.3502 106.669 55.1985C106.873 55.1226 107.036 55.064 107.152 55.0232C107.21 55.0028 107.256 54.9868 107.289 54.9752L107.33 54.9612L107.348 54.9551L107.351 54.9539C107.352 54.9536 107.351 54.9539 108.544 58.4872C112.168 57.6082 112.168 57.6075 112.168 57.6082L112.17 57.6162L112.174 57.6298L112.184 57.6733L112.219 57.8245C112.249 57.9531 112.29 58.1365 112.34 58.3694C112.441 58.8347 112.577 59.4991 112.727 60.3185C113.027 61.9528 113.385 64.227 113.616 66.7845C114.059 71.6896 114.12 78.4351 111.725 83.5412C108.763 89.8564 102.932 92.9809 98.3974 94.5274C96.0811 95.3174 93.9463 95.752 92.393 95.9909C91.6123 96.1109 90.9676 96.1831 90.5068 96.2259C90.2762 96.2473 90.0908 96.2614 89.9566 96.2704C89.8894 96.275 89.835 96.2782 89.7941 96.2805L89.7428 96.2832L89.7249 96.2841L89.7179 96.2844L89.7149 96.2845C89.7135 96.2846 89.7122 96.2847 89.5462 92.5592ZM86.0452 93.8437L89.5462 92.5592L89.7122 96.2847C88.0885 96.357 86.605 95.3695 86.0452 93.8437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.851 82.0142C109.333 75.7677 107.284 63.0633 107.284 63.0633C96.931 73.819 94.3249 85.7694 93.7336 90.0847C93.7336 90.0847 102.368 88.2607 105.851 82.0142Z",
    fill: "#6FC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0876 76.0447C73.6726 76.9013 85.5584 87.0147 88.8906 93.312C89.1686 93.8374 90.6025 93.0151 90.3665 92.555C88.4665 86.5569 82.4056 72.399 77.5317 68.1322C71.1118 67.997 69.8858 74.6956 70.0876 76.0447Z",
    fill: "#943D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2212 79.6718C67.7414 79.3182 66.6248 78.1012 66.3997 76.5965C66.2494 75.5919 66.3971 74.3957 66.6281 73.3874C66.8845 72.2682 67.3456 70.9333 68.1197 69.6288C69.7408 66.8969 72.7883 64.3023 77.6105 64.4039C78.4869 64.4223 79.3288 64.7489 79.9884 65.3264C81.6089 66.7451 83.1281 68.7855 84.4745 70.9059C85.854 73.0785 87.1944 75.5648 88.4136 78.0541C90.8005 82.9277 92.8341 88.042 93.8668 91.2563C94.6328 93.22 93.5369 94.8281 93.2003 95.2539C92.6976 95.8899 92.0886 96.3157 91.6004 96.5806C91.1218 96.8404 90.387 97.148 89.4999 97.2023C88.6491 97.2544 86.6516 97.0536 85.5947 95.0562C84.2559 92.526 80.877 88.7893 77.1015 85.4207C75.2689 83.7857 73.4592 82.3411 71.934 81.2756C71.1702 80.7421 70.5155 80.33 69.9921 80.0423C69.5189 79.7823 69.2772 79.6932 69.2274 79.6749C69.2168 79.671 69.2149 79.6703 69.2212 79.6718ZM90.3668 92.5551C90.3646 92.5482 90.3624 92.5414 90.3603 92.5345C90.1076 91.7385 89.7823 90.8001 89.3966 89.7611C88.9069 88.4415 88.3198 86.9596 87.6607 85.4009C84.9206 78.9202 80.9366 71.1129 77.532 68.1322C71.1121 67.997 69.886 74.6956 70.0879 76.0447C72.6724 76.6623 79.5713 82.0911 84.4691 87.4326C85.5055 88.5629 86.4524 89.6894 87.2498 90.7655C87.8431 91.5663 88.3537 92.3392 88.7569 93.0651C88.8029 93.148 88.8476 93.2304 88.8908 93.3121C89.1688 93.8374 90.6027 93.0151 90.3668 92.5551ZM86.7792 93.579C86.8415 93.7981 86.9295 94.0247 87.0486 94.2569C86.9537 94.072 86.8745 93.8794 86.8117 93.6812C86.801 93.6474 86.7902 93.6134 86.7792 93.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7734 68.2567C79.9447 69.5063 79.1287 72.1743 76.9507 74.2159C74.7728 76.2575 72.0577 76.8996 70.8863 75.6501C69.715 74.4005 70.531 71.7325 72.7089 69.6909C74.8869 67.6493 77.602 67.0072 78.7734 68.2567Z",
    fill: "#C26649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2433 92.5669C77.175 94.9941 78.2215 102.959 74.5807 110.356C70.9399 117.754 63.9905 121.783 59.0588 119.356C54.127 116.929 53.0806 108.964 56.7214 101.567C60.3622 94.169 67.3116 90.1397 72.2433 92.5669Z",
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5338 98.5041C68.1154 99.8233 68.3281 102.175 67.0089 103.756C66.1497 104.786 65.5876 105.873 65.2746 107.037C64.7396 109.026 62.6936 110.204 60.7047 109.669C58.7159 109.134 57.5373 107.088 58.0723 105.099C58.6791 102.844 59.7647 100.797 61.2814 98.9791C62.6007 97.3975 64.9523 97.1848 66.5338 98.5041Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1645",
    x: -2.58889,
    y: -2.58889,
    width: 188.989,
    height: 239.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.647222,
    dy: 0.647222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61806
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1645",
    x: 37.9043,
    y: 52.1579,
    width: 122.913,
    height: 138.087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.993115 0 0 0 0 0.743134 0 0 0 0 0.689567 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.517,
    height: 233,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedApple);
export default __webpack_public_path__ + "static/media/redApple.1a1638c8c13caa303753afdc6546a0ce.svg";
export { ForwardRef as ReactComponent };